import 'bootstrap/dist/css/bootstrap.min.css';

import MyNav from './components/nav';
import MyFooter from "./components/footer";

import './App.css';
import React from 'react'
import HomePage from "./pages/home";
import AboutMe from "./pages/aboutMe";
import Art from "./pages/artPortfolio";
import Contact from "./pages/contact";
import Tech from "./pages/techPortfolio";
import Blog from './pages/blog';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

function App() {
    // let Component;
    // switch(window.location.pathname){
    //     case "/":
    //         Component = HomePage
    //         break
    //     case "/aboutMe":
    //         Component = AboutMe
    //         break
    //     case "/artPortfolio":
    //         Component = Art
    //         break
    //     case "/techPortfolio":
    //         Component = Tech
    //         break
    //     case "/contact":
    //         Component = Contact
    //         break
    // }
  return(
      <>
          <MyNav/>
          {/* <Component/> */}
          <BrowserRouter>
            <Routes>
                <Route path='/siya-portfolio/' element={<HomePage/>}></Route>
                <Route path='/siya-portfolio/aboutMe' element={<AboutMe/>}></Route>
                <Route path='/siya-portfolio/artPortfolio' element={<Art/>}></Route>
                <Route path='/siya-portfolio/techPortfolio' element={<Tech/>}></Route>
                {/* <Route path='/siya-portfolio/blog' element={<Blog/>}></Route> */}
                <Route path='/siya-portfolio/contact' element={<Contact/>}></Route>
            </Routes>
          </BrowserRouter>
          <MyFooter/>
      </>
  )
}

export default App;
